import React, { useState, type FC } from "react";
import { Box, FlexRow, Glyph } from "@edreamsodigeo/prisma-design-system";
import {
  Trans,
  useTracking,
  useTranslation,
} from "@edreamsodigeo/frontend-core";

import { BenefitsModal } from "~/components/common/BenefitsModal";
import { freeTrialDays, renewalTimeKey } from "~/tools/subscriptionUtils";
import { StyledPrice } from "~/components/common/StyledPrice";
import type { PrimePriceDisclaimerProps } from "~/components/engage/DualPriceStickyBar/contract";
import { useTrackingContext } from "./DualPriceTrackingProvider";
import { YearlyWithMonthlyDisclaimer } from "~/components/engage/DualPriceStickyBar/components/YearlyWithMonthlyDisclaimer";

export const PrimePriceDisclaimer: FC<PrimePriceDisclaimerProps> = ({
  offer,
  savings,
  customKeys,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const { trackingCategory } = useTrackingContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (): void => {
    trackEvent({
      category: trackingCategory,
      action: "prime-fare",
      label: "prime-fare_click:info_pag:summary",
    });
    setIsModalOpen(true);
  };

  return (
    <>
      <Box display={"inline-block"}>
        <FlexRow flexWrap={"wrap"} gap={"1"}>
          <Trans
            i18nKey={"prime.dualPriceMobile.discounted.disclaimer"}
            values={{
              freeTrialDays: freeTrialDays(offer.duration),
            }}
            components={{
              renewalPrice: <StyledPrice money={offer.renewalPrice} />,
              renewalPeriod: t(renewalTimeKey(offer?.renewalDuration)),
            }}
          />
          <YearlyWithMonthlyDisclaimer offer={offer} />
          <Glyph
            data-testid={"infoIcon"}
            aria-label={t("prime.dualPriceMobile.discounted.moreInfo")}
            sx={{
              ml: "2x_small",
              cursor: "pointer",
              transform: "translateY(2px)",
            }}
            name={"InfoCircle"}
            category={"Alerts"}
            size={"tiny"}
            onClick={handleOpenModal}
          />
        </FlexRow>
      </Box>
      <BenefitsModal
        offer={offer}
        isOpen={isModalOpen}
        setOpen={setIsModalOpen}
        savings={savings}
        customKeys={customKeys}
      />
    </>
  );
};
